import { render } from "./twoFactorAuthenticator.vue?vue&type=template&id=11e430a2&ts=true"
import script from "./twoFactorAuthenticator.vue?vue&type=script&lang=ts"
export * from "./twoFactorAuthenticator.vue?vue&type=script&lang=ts"

import "./twoFactorAuthenticator.vue?vue&type=style&index=0&id=11e430a2&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__